module.exports = __webpack_public_path__ + "img/pic_dxyx@2x.9f74fbce.png";